import { defaultIsEmptyText } from '@doltech/ui/lib/shared/components/IELTSample/Outline/Paragraph/components/EditorPlaceHolder';
import { SectionDescriptionSectionTypeEnum } from '@doltech/utils/lib/constants';
import * as React from 'react';

import { getSectionDescriptionByType } from '../../sample.utils';
import { BlogEditorReadOnlyWithStylesWithoutStore } from '@doltech/ui/lib/figma/BlogEditor/BlogEditorReadOnlyWithStylesPlugin';

interface SectionDescriptionPreviewProps {
  detailData: any;
  sectionType: SectionDescriptionSectionTypeEnum;
}

export const SectionDescriptionPreview = ({
  detailData,
  sectionType,
}: SectionDescriptionPreviewProps) => {
  const sectionDescription = getSectionDescriptionByType(detailData, sectionType, true);
  const isEmptyText = defaultIsEmptyText(sectionDescription?.content?.[0]);
  if (isEmptyText) {
    return null;
  }
  return (
    <BlogEditorReadOnlyWithStylesWithoutStore
      isReadOnly
      initialValue={sectionDescription?.content}
    />
  );
};
